export function classBasename(string: string): string {
    return string
        .replace(/\\+?/guim, '/')
        .split('/')
        .filter(Boolean)
        .at(-1) ?? string;
}
